module.exports = __webpack_public_path__ + "img/logo-home-bzuco.c06b2754.png";